module.exports = __webpack_public_path__ + "img/promotions.616776f1.svg";